module.exports = __webpack_public_path__ + "static/media/derramamento.ddde6b8e.svg";